"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchLog_1 = __importDefault(require("./fetchLog"));
var utils_1 = require("./utils");
var types_1 = require("./types");
var windowInit_1 = __importDefault(require("./init/windowInit"));
var wxInit_1 = __importDefault(require("./init/wxInit"));
var genLog = function () {
    var env = "";
    var tenantId = "";
    var runtimeEnv = "";
    var serviceCode = "";
    var getCustomizeContent = function () {
        return "";
    };
    var init = function (args) {
        env = (0, utils_1.getEnv)(args.env);
        tenantId = args.tenantId;
        runtimeEnv = args.runtimeEnv || types_1.EnumRuntimeEnv.WINDOW;
        serviceCode = args.serviceCode;
        getCustomizeContent = args.getCustomizeContent || function () { };
        switch (runtimeEnv) {
            case types_1.EnumRuntimeEnv.WX:
                (0, wxInit_1.default)(__assign(__assign({}, args), { env: env, getCustomizeContent: getCustomizeContent }), errorLog);
                break;
            case types_1.EnumRuntimeEnv.WINDOW:
                (0, windowInit_1.default)(__assign(__assign({}, args), { env: env, getCustomizeContent: getCustomizeContent }), errorLog);
                break;
            default:
                (0, windowInit_1.default)(__assign(__assign({}, args), { env: env, getCustomizeContent: getCustomizeContent }), errorLog);
        }
    };
    var log = function (content, level) {
        var customizeContent = getCustomizeContent();
        if (typeof customizeContent !== "string")
            customizeContent = JSON.stringify(customizeContent);
        // 获取页面地址
        var url = (0, utils_1.getCurrentUrl)(runtimeEnv);
        // fetchLog(env, runtimeEnv, {
        //     tenantId,
        //     level,
        //     serviceCode,
        //     content: encodeURIComponent(`${content}
        //     clientTime:${Date()}
        //     customizeContent:${customizeContent}
        //     url:${url}`)
        // })
        (0, fetchLog_1.default)(env, runtimeEnv, {
            tenantId: tenantId,
            level: level,
            serviceCode: serviceCode,
            content: encodeURIComponent(JSON.stringify({
                content: content,
                clientTime: Date(),
                customizeContent: customizeContent,
                url: url,
            })),
        });
    };
    var errorLog = function (content) { return log(content, types_1.EnumLevel.ERROR); };
    var infoLog = function (content) { return log(content, types_1.EnumLevel.INFO); };
    // JSON.stringify 处理传入的content,为了方便使用
    var error = function () {
        var argus = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argus[_i] = arguments[_i];
        }
        return errorLog(JSON.stringify(argus));
    };
    var info = function () {
        var argus = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argus[_i] = arguments[_i];
        }
        return infoLog(JSON.stringify(argus));
    };
    return {
        init: init,
        error: error,
        info: info,
    };
};
exports.default = genLog;
